__webpack_require__.p = "/verificaqr/";